import { render, staticRenderFns } from "./QuestionnaireComparisonModal.vue?vue&type=template&id=44f140bc&scoped=true&"
import script from "./QuestionnaireComparisonModal.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireComparisonModal.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireComparisonModal.vue?vue&type=style&index=0&id=44f140bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f140bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
